<div class="trial-link-main">
  <div class="trial-link-main__title">
    <p class="vox-heading-2" translate>sales.trial-link.title</p>
  </div>
  <hr />
  <div class="trial-link-main__container">
    <div class="trial-link-main__container-tab">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
